import React from 'react';
import { UseFormRegister, FieldError, RegisterOptions } from 'react-hook-form';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  name: string;
  register: UseFormRegister<any>; // eslint-disable-line @typescript-eslint/no-explicit-any
  rules?: RegisterOptions;
  error?: FieldError;
}

const Input: React.FC<InputProps> = ({ label, name, register, rules, error, type = 'text', ...rest }) => {
  const inputId = `input-${name}`;
  return (
    <div className="mb-4">
      <label htmlFor={inputId} className="block text-sm font-medium text-foreground mb-1">
        {label}
      </label>
      <input
        id={inputId}
        type={type}
        {...register(name, rules)}
        {...rest}
        className={`mt-1 block w-full px-3 py-2 rounded-md border bg-background text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background ${error ? 'border-destructive' : 'border-input'}`}
        aria-invalid={error ? 'true' : 'false'}
      />
      {error && <p className="mt-1 text-xs text-destructive">{error.message}</p>}
    </div>
  );
};

export default Input;
